<template>
  <div class="w120 mc mt20 pt20 pb20 pl20 pr20 bg-w my-office">
    <!-- <el-tabs v-model="activeName">
      <el-tab-pane lazy v-for="(item, index) in tabData" :key="index" :label="item.label" :name="item.activeName">
        <ServerOfficeList :active-name="activeName" :title="item.label" :get-url="item.getUrl" :post-url="item.postUrl" :get-excel="item.getExcel"></ServerOfficeList>
      </el-tab-pane>
    </el-tabs> -->
    <!-- <ServerOfficeList :active-name="activeName" title="全部事务" get-url="task/0/getDataModel" post-url="task/0/findTaskPage" get-excel="wholeTask/exportData"></ServerOfficeList> -->
    <p class="pb20 w100 tx-c font-18">事务查询</p>
    <CardMyOfficeSWCX />
  </div>
</template>

<script>
// import ServerOfficeList from "@/components/ServerOfficeList";
import CardMyOfficeSWCX from "@/components/CardMyOffice/CardMyOfficeSWCX";

export default {
  name: "server_my_office",
  components: {
    // ServerOfficeList
    CardMyOfficeSWCX
  },
  data() {
    return {

      loading: false,
      error: 0

      // activeName: this.$route.query.active_name || "0"
      // tabData: [
      //   {
      //     component: "ServerOfficeList",
      //     activeName: "0",
      //     label: "全部事务",
      //     getUrl: "task/0/getDataModel",
      //     postUrl: "task/0/findTaskPage",
      //     getExcel: "wholeTask/exportData"
      //   }
      // {
      //     component: 'ServerOfficeList',
      //     activeName: '1',
      //     label: '待办事务',
      //     getUrl: 'task/1/getDataModel',
      //     postUrl: 'task/1/findTaskPage',
      //     getExcel: 'wholeTask/exportData'
      // },
      // {
      //     component: 'ServerOfficeList',
      //     activeName: '2',
      //     label: '办结事务',
      //     getUrl: 'task/2/getDataModel',
      //     postUrl: 'task/2/findTaskPage',
      //     getExcel: 'wholeTask/exportData'
      // }
      // {
      //     component: 'ServerOfficeList',
      //     activeName: '3',
      //     label: '委托记录',
      //     getUrl: 'task/3/getDataModel',
      //     postUrl: 'task/3/findTaskPage',
      //     getExcel: 'wholeTask/exportData'
      // }
      // ]
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style scoped>
</style>
